//// The semi-colon before the function invocation is a safety 
//// net against concatenated scripts and/or other plugins 
//// that are not closed properly.
//; (function ($, window, document, undefined) {

//    // undefined is used here as the undefined global 
//    // variable in ECMAScript 3 and is mutable (i.e. it can 
//    // be changed by someone else). undefined isn't really 
//    // being passed in so we can ensure that its value is 
//    // truly undefined. In ES5, undefined can no longer be 
//    // modified.

//    // window and document are passed through as local 
//    // variables rather than as globals, because this (slightly) 
//    // quickens the resolution process and can be more 
//    // efficiently minified (especially when both are 
//    // regularly referenced in your plugin).

//    // Create the defaults once
//    var pluginName = 'tagfilter';
//    var defaults = {};
    
//    // The actual plugin constructor
//    function Plugin(element, options) {
//        this.element = element;
//        this.$element = $(element);

//        this.options = $.extend({}, defaults, options);

//        this._defaults = defaults;
//        this._name = pluginName;
        
//        this.init();
//    }

//    Plugin.prototype.init = function () {

//        var $base = this;

//        $base.$element.on('click', 'a', function (e) {
//            var hash = $(this).attr('href');
//            if ($(this).hasClass('active')) {
//                e.preventDefault();
//                history.pushState("", document.title, window.location.pathname);
//                hash = null;
//            }

//            $base.filterList(hash);
//        });

//        $base.filterList();
//    };

//    Plugin.prototype.filterList = function(hash) {

//        var $base = this;

//        if (!hash) {
//            hash = window.location.hash;
//        }

//        // Filter and set active
//        $('a', $base.$element).removeClass('active');
//        $('a[href="' + hash + '"]', $base.$element).addClass('active');

//        var $listWrapper = $base.$element.siblings('.row');

//        if (!hash) {
//            $('*[data-tags]', $listWrapper).removeClass('hidden');
//            return;
//        }

//        // Filter
//        $('*[data-tags]', $listWrapper).addClass('hidden');
//        $('*[data-tags*="' + hash.replace('#', '') + '"]', $listWrapper).removeClass('hidden');
//    };
    
//    // A really lightweight plugin wrapper around the constructor, 
//    // preventing against multiple instantiations
//    $.fn[pluginName] = function (options) {
//        return this.each(function () {
//            if (!$.data(this, pluginName)) {
//                $.data(this, pluginName, new Plugin(this, options));
//            }
//        });
//    };
//})(jQuery, window, document);


//$(document).ready(function () {
    
//    $('.dropdown-menu a.dropdown-toggle').on('click', function (e) {
//        var $el = $(this);
//        var $parent = $(this).offsetParent('.dropdown-menu');
//        if (!$(this).next().hasClass('show')) {
//            $(this).parents('.dropdown-menu').first().find('.show').removeClass('show');
//        }
//        var $subMenu = $(this).next('.dropdown-menu');
//        $subMenu.toggleClass('show');

//        $(this).parent('li').toggleClass('show');

//        $(this).parents('li.nav-item.dropdown.show').on('hidden.bs.dropdown', function (e) {
//            $('.dropdown-menu .show').removeClass("show");
//        });

//        if (!$parent.parent().hasClass('navbar-nav')) {
//            $el.next().css({ "top": $el[0].offsetTop, "left": $parent.outerWidth() - 4 });
//        }

//        return false;
//    });

//    $(document).on('click', '[data-toggle="lightbox"]', function (e) {
//        e.preventDefault();
//        $(this).ekkoLightbox({
//            showArrows: true
//        });
//    });

//    $(document).on('click', '.cookies-close', function () {
//        var $moduleBody = $(this).parent();
//        $moduleBody.addClass('pressed');
//        var $moduleBodyHeight = $moduleBody.outerHeight();
//        $moduleBody.css('margin-top', -$moduleBodyHeight);

//        setTimeout(function () {
//            var days = 30;
//            var date = new Date();
//            date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));

//            var expires = date.toGMTString();
//            document.cookie = 'accepted_cookies=true; expires=' + expires + '; path=/';
//        }, 260);
//    });

//    $('.tag-filters').tagfilter();
//});
